import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';
import ListAltIcon from '@material-ui/icons/ListAlt';
import EventIcon from '@material-ui/icons/Event';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import ListItemText from '@material-ui/core/ListItemText';
import { LocalLibrary, AccountCircle, MonetizationOn } from '@material-ui/icons';

import { Link } from '@material-ui/core';

// import PlanForm from './PlanForm';
// import PlanAssignmentForm from './PlanAssignmentForm';

import Actions from '../actions';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    tab: {
      label: {
        background: '#aa0',
        fontSize: '22px',
      },
    },
  };
});

// function TabPanel(props) {
//     const { children, value, index, ...other } = props;

//     return (
//       <Typography
//         component="div"
//         role="tabpanel"
//         hidden={value !== index}
//         id={`simple-tabpanel-${index}`}
//         aria-labelledby={`simple-tab-${index}`}
//         {...other}
//       >
//         {value === index && children}
//       </Typography>
//     );
//   }

//   TabPanel.propTypes = {
//     children: PropTypes.node,
//     index: PropTypes.any.isRequired,
//     value: PropTypes.any.isRequired,
//   };

// function a11yProps(index) {
//     return {
//       id: `vertical-tab-${index}`,
//       'aria-controls': `vertical-tabpanel-${index}`,
//     };
// }

function PersistentDrawerLeft(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  // const [value, setValue] = React.useState(0);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const logout = () => {
    props.logout();
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar style={{ background: '#583c5c' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            <Link href="/dashboard" variant="inherit" color="inherit" style={{ textDecoration: 'none' }}>
              Stamurai Dashboard
            </Link>
          </Typography>
          <div style={{ marginLeft: 'auto' }}>
            {/* <Button color="inherit">
              <Link href="/"  color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>Home</Link>
              </Button>
              <Button color="inherit">
              <Link href="/add"  color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>Create Template</Link>
              </Button>               */}
            <Button color="inherit" onClick={() => { return logout(); }}>Logout</Button>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        {/* <Tabs
            orientation="vertical"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs"
            centered={false}
            className={classes.tabs}
        >
            {/* <Tab style={{ labelContainer: { textALign: 'left' } }} label="Create Plan" {...a11yProps(0)} /> */}
        {/* <Tab style={{ labelContainer: { textALign: 'left' } }} /> */}
        {/* <Tab label="Create Task Template" {...a11yProps(0)} /> */}
        {/* <Tab label="Plan Assignment" {...a11yProps(2)} /> */}
        {/* </Tabs> */}
        <List>
          <Link href="/dashboard" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><HomeIcon /></ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>
          </Link>
          <Link href="/dashboard/templates" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><ListAltIcon /></ListItemIcon>
              <ListItemText primary="Templates" />
            </ListItem>
          </Link>
          <Link href="/dashboard/reports" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
              <ListItemText primary="User Report" />
            </ListItem>
          </Link>
          <Link href="/dashboard/addcalltype" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><VideoCallIcon /></ListItemIcon>
              <ListItemText primary="Call Type Form" />
            </ListItem>
          </Link>
          <Link href="/dashboard/addcallslot" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><EventIcon /></ListItemIcon>
              <ListItemText primary="Call Slot Form" />
            </ListItem>
          </Link>
          <Link href="/dashboard/viewslots" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><DateRangeIcon /></ListItemIcon>
              <ListItemText primary="Call Details" />
            </ListItem>
          </Link>
          <Link href="/dashboard/therapistassignments" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
              <ListItemText primary="Therapist Assignments" />
            </ListItem>
          </Link>
          <Link href="/dashboard/add-dashboard-user" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><PersonAddIcon /></ListItemIcon>
              <ListItemText primary="Add Dashboard User" />
            </ListItem>
          </Link>
          <Link href="/dashboard/speech-therapist-session" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><LocalLibrary /></ListItemIcon>
              <ListItemText primary="Add Speech therapist sessions" />
            </ListItem>
          </Link>
          <Link href="/dashboard/add-therapist" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><AccountCircle /></ListItemIcon>
              <ListItemText primary="Add Therapist" />
            </ListItem>
          </Link>
          <Link href="/dashboard/multitemplate" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><ListAltIcon /></ListItemIcon>
              <ListItemText primary="MultiTemplates" />
            </ListItem>
          </Link>
          <Link href="/dashboard/create-offer" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><MonetizationOn /></ListItemIcon>
              <ListItemText primary="Create Offer" />
            </ListItem>
          </Link>
          <Link href="/dashboard/video-exercise" color="inherit" variant="inherit" style={{ textDecoration: 'none' }}>
            <ListItem button key="Template">
              <ListItemIcon><OndemandVideoIcon /></ListItemIcon>
              <ListItemText primary="Add Video Exercise" />
            </ListItem>
          </Link>
        </List>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
        style={{ background: '#f4f4f4', minHeight: '100vh' }}
      >
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 40,
        }}
        >
          {/* <TabPanel value={value} index={0}>
                <PlanForm />
            </TabPanel> */}
          {/* <TabPanel value={value} index={0}>
                <TaskTemplateForm />
            </TabPanel> */}
          {/* <TabPanel value={value} index={2}>
                <PlanAssignmentForm />
              </TabPanel> */}
          {props.children}
        </div>
      </main>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(null, mapDispatchToProps)(PersistentDrawerLeft);
